import Cropper from "./Cropper";

export default Cropper;
